<template>
  <view-with-bar>
    <template slot="bar">
      <view-bar>
        <h1>{{ $t("administration.operations")}}</h1>
        <view-bar-item route="/administration/operation-definitions">{{ $t("administration.operationDefinitions")}}</view-bar-item>
        <view-bar-item route="/administration/operation-definition-groups">{{ $t("administration.operationDefinitionGroups")}}</view-bar-item>
        <view-bar-item route="/administration/operation-link-definitions">{{ $t("administration.operationLinkDefinitions")}}</view-bar-item>
        <view-bar-item route="/administration/cash-event-generation-scripts">{{ $t("administration.cashEventGenerationScripts")}}
        </view-bar-item>
        <view-bar-item route="/administration/operation-links">{{ $t("administration.operationLinks")}}</view-bar-item>
        <h1>{{$t("administration.security")}}</h1>
        <view-bar-item route="/administration/users">{{ $t("administration.users")}}</view-bar-item>
        <view-bar-item route="/administration/security-groups">{{ $t("administration.securityGroups")}}</view-bar-item>

        <!--                <view-bar-item route="/administration/operation-groups">Operation groups</view-bar-item>-->
        <!--                <view-bar-item route="/administration/operation-param-synonyms">Operation parameter synonyms</view-bar-item>-->

        <!--                <view-bar-item route="/administration/party-role-types">Party role types</view-bar-item>-->
        <!--                <view-bar-item route="/administration/setup">Cash-flow setup</view-bar-item>-->

      </view-bar>
    </template>
  </view-with-bar>
</template>

<script>
import ViewWithBar from "../components/layout/ViewWithBar";
import ViewBar from "../components/navigation/ViewBar";
import ViewBarItem from "../components/navigation/ViewBarItem";

export default {
  name: "AdministrationView",
  components: {ViewBarItem, ViewBar, ViewWithBar}
}
</script>

<style scoped>

</style>